import { format, isValid } from "date-fns";

/**
 * Ensure we always end up with a canonical YYYY-MM-DD string or undefined
 */
function toIsoDate(value: string | Date | null | undefined): string | undefined {
  if (!value) return undefined;

  if (typeof value === "string") {
    return value;
  }

  if (value instanceof Date && isValid(value)) {
    const utcDate = new Date(Date.UTC(value.getUTCFullYear(), value.getUTCMonth(), value.getUTCDate()));
    return format(utcDate, "yyyy-MM-dd");
  }

  throw new Error(`Unsupported date value: ${value}`);
}

export default toIsoDate;
